import React from "react";
import styles from "./industry.module.css";
import { Section } from "../../../../COMPONENTS/UI";
import TextReveal from "../../../../COMPONENTS/ANIMATION/TextReveal";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import { industry, promises } from "../../../../CONTENT/sponsors";

const Industry = () => (
  <Section tone="light" id="difference" labelledBy="difference-title">
    <div className={styles.layout}>
      <Reveal className={styles.problem}>
        <p className={styles.eyebrow}>The challenge</p>
        <TextReveal as="h2" id="difference-title" className={styles.title} stagger={0.035}>
          {industry.problem.lead}
        </TextReveal>
        <dl className={styles.stats}>
          {industry.problem.stats.map((s) => (
            <div key={s.value} className={styles.stat}>
              <dt className={styles.statText}>{s.text}</dt>
              <dd className={styles.statValue}>{s.value}</dd>
            </div>
          ))}
        </dl>
        <p className={styles.question}>{industry.problem.question}</p>
      </Reveal>

      <Reveal delay={0.12} className={styles.answer}>
        <p className={styles.eyebrowDark}>The KUR difference</p>
        <h3 className={styles.answerTitle}>{industry.answer.title}</h3>
        {industry.answer.paragraphs.map((p) => (
          <p key={p} className={styles.answerText}>
            {p}
          </p>
        ))}
        <p className={styles.promiseLabel}>One Company, One Solution delivers</p>
        <ul className={styles.promises}>
          {promises.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
      </Reveal>
    </div>
  </Section>
);

export default Industry;
